import styled from 'styled-components';

export const FormRow = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.minWidth.S}) {
    display: flex;
    flex-direction: row;
    > div {
      margin-left: 5px;
      margin-right: 5px;
    }
    > div:first-child {
      margin-left: 0;
      margin-right: 5px;
    }
    > div:last-child {
      margin-left: 5px;
      margin-right: 0;
    }

    &.weightLeft {
      & > div:first-child {
        flex: 0.7;
      }
      & > div:last-child {
        flex: 0.3;
      }
    }

    &.weightRight {
      & > div:first-child {
        flex: 0.3;
      }
      & > div:last-child {
        flex: 0.7;
      }
    }
  }
`;
